import React from 'react';
import { Dialog, Portal } from 'react-native-paper';
import { t, Trans } from '@lingui/macro';
import { useTheme } from '@react-navigation/native';
import styled from 'styled-components/native';

import FontIcon from '@src/components/FontIcon';
import HeadTourPlus from '@src/components/HeadTourPlus';
import ImageIcon from '@src/components/ImageIcon';
import { Body1, Body4, H1 } from '@src/components/Typography';
import { i18n } from '@src/i18n';

type Props = {
  visible?: boolean;
  onDismiss?: () => void;
};
type rowProps = {
  title: string;
};
const BodyItem = styled(Body4)`
  color: ${({ theme }) => theme.colors.secondary};
  padding-left: 8px;
  margin-top: -2;
`;

const TitleItem = styled(H1)`
  text-align: left;
  font-weight: bold;
  margin-top: 30;
  margin-bottom: 16;
`;
const Row = styled.View`
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const ItemPlus = styled(Body1)`
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 2px;
`;

const TourItem = ({ title }: rowProps) => {
  return (
    <Row>
      <ImageIcon source={require('@src/assets/images/check.png')} size={12} />
      <BodyItem>{title}</BodyItem>
    </Row>
  );
};

const TourPlusModal: React.FC<Props> = ({ visible, onDismiss }) => {
  return (
    <Portal>
      <Dialog visible={!!visible} onDismiss={onDismiss}>
        <Dialog.Content
          style={{
            alignItems: 'center',
            paddingTop: 16,
            width: '100%',
          }}
        >
          <ImageIcon
            source={require('@src/assets/images/tourPlus.png')}
            size={104}
          />
          <HeadTourPlus
            children={<Trans>body</Trans>}
            titlePlus={`${i18n._(t`Standard`)}`}
            titleSuffixPlus={`${i18n._(t`Youtopin`)}`}
          />
          <TitleItem>
            <Trans>TourPlusTitle</Trans>
          </TitleItem>
          <TourItem title={`${i18n._(t`service_a`)}`} />
          <TourItem title={`${i18n._(t`service_b`)}`} />
          <TourItem title={`${i18n._(t`service_c`)}`} />
          <TourItem title={`${i18n._(t`service_d`)}`} />
        </Dialog.Content>
      </Dialog>
    </Portal>
  );
};

export default TourPlusModal;
